import { render, staticRenderFns } from "./ReadView.vue?vue&type=template&id=83d22b90&scoped=true&"
import script from "./ReadView.vue?vue&type=script&lang=js&"
export * from "./ReadView.vue?vue&type=script&lang=js&"
import style0 from "./ReadView.vue?vue&type=style&index=0&id=83d22b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d22b90",
  null
  
)

export default component.exports